import removeInpAlerts from './lib/removeInpAlerts';

import popupBut from './lib/popupBut';

import popup from './lib/popup';

import reportFormSet from './lib/reportFormSet';

import reportFormSend from './lib/reportFormSend';

import loadMore from "./lib/loadMore";

removeInpAlerts();

popupBut();

popup();

reportFormSet();

reportFormSend();

function initLoadMoreLatest(){
    loadMore('#load-more-all', '#respons-all');
}
if(document.querySelector('#load-more-all')){
    const loadmoreLatestBut = document.querySelector('#load-more-all');
    loadmoreLatestBut.addEventListener('click', initLoadMoreLatest, false);
}